/********************************************************************************
 * File Header - Constants
 * Created By: Marlon Alejandro Mendez Castañeda
 * Contact: +57 3234686680
 * Date: March 14, 2024
 *
 * Description:
 * This is the implementation of the Constants interface, and it is used to store the
 * constants of the dev enviroment
 *  If I want to use the PC as server the IP is the link
 ********************************************************************************/

import RestApi from "../RestApi";
import Constants from "./Constants";

const ConstantsDev: Constants = {
    HOST_URL: localStorage.getItem((new RestApi()).getUrl()) ?? undefined,
    HOST_IMAGE_URL: "https://audix.blackpool.la",
    DEFAULT_IMAGE_URL: "",
    GOOGLE_MAPS_API_KEY: "",
}

export default ConstantsDev;